module.exports = "<rnpl-icon iconName=\"R_blue\" autoPlay=\"true\" width=\"64px\" height=\"64px\"></rnpl-icon>"